<template>
  <v-card style="border-radius: 12px;" :max-width="$vuetify.breakpoint.smAndUp ? '450px' : 'auto'">
    <v-card-title class="heading">
      <v-row align="center" class="ma-0">

        <span style="color: #47464A; font-weight: 600;" v-if="Feature['nm_field']">{{ Feature["nm_field"] || ""
        }}</span>
        <span style="color: #47464A; font-weight: 600;" v-else>Draw Area</span>
        <v-spacer />
        <v-btn icon depressed @click="onSaveClick" :loading="isUpdating">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.16669 10L8.33335 14.1667L16.6667 5.83337" stroke="#6CBE44" stroke-width="1.66667"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </v-btn>
        <v-btn icon depressed @click="onCloseClick" :disabled="isUpdating">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15" stroke="#47464A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5 5L15 15" stroke="#47464A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </v-btn>
      </v-row>
    </v-card-title>
    <v-card-text class="pb-0">
      <v-container fluid class="fill-height pa-0">
        <v-row class="ma-0">
          <v-col cols="12">
            <v-text-field label="Name" v-model="fieldData.nmField" clearable outlined hide-details>
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-row align="center" class="ma-0">
              <span class="body-1"><b>Area: </b> {{ Feature["fl_area"] | toAreaUnit(fieldData.abAreaUnit) |
                floatToFixedWithComma }}</span>
              <v-spacer />
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="px-0">
                <v-select label="Area Unit" v-model="fieldData.abAreaUnit" :items="areaUnitTypesList" outlined
                  hide-details dense>
                </v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

  </v-card>
</template>

<script>
import { FEATURE_CARD_STATE } from "../../../../helpers/geometries/constants"
import { cloneDeep } from "lodash/lang"
import Wkt from "wicket"
import { getFloatAreaInUnit } from "../../../../helpers/spatial"
import { AREA_UNIT_TYPES_LIST } from "../../../../helpers/fields/constants"
import { FloatingCardsEventBus } from "../../../../helpers/mapview/events"
import { toFixed } from "../../../../helpers/utils"

const _FieldLayer = Symbol.for("_FieldLayer")
const _FieldFeature = Symbol.for("_FieldFeature")

export default {
  name: "FieldEditCard",
  inject: { _FieldFeature, _FieldLayer },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isUpdating: false,
    bkpLayer: null,
    bkpFieldData: {
      nmField: null,
      abAreaUnit: null,
    },
    fieldData: {
      nmField: null,
      abAreaUnit: null,
    },
  }),
  methods: {
    onCloseClick() {
      FloatingCardsEventBus.$emit("close")
    },
    onCancelClick() {
      this.fieldData = cloneDeep(this.bkpFieldData)
      this.Layer.setLatLngs(this.bkpLayer.getLatLngs())
      this.Layer.disableEdit()
      this.Layer.dragging.disable()
      this.$emit("update:mode", FEATURE_CARD_STATE.VIEW)
    },
    onSaveClick() {
      const geoJSON = this.Layer.toGeoJSON(),
        wkt = new Wkt.Wkt(),
        geoJsonWkt = wkt.read(JSON.stringify(geoJSON["geometry"])).write()
      const fieldData = {
        nm_field: this.fieldData.nmField,
        geo_field: geoJsonWkt,
        ab_area_unit: this.fieldData.abAreaUnit,
      }

      this.isUpdating = true
      this.Feature.update(this.Feature["id_field"], fieldData)
        .then(() => {
          this.bkpLayer = cloneDeep(this.Layer)
          this.Layer.disableEdit()
          this.Layer.dragging.disable()
          this.$emit("update:mode", FEATURE_CARD_STATE.VIEW)
        })
        .finally(() => {
          this.isUpdating = false
        })
    }
  },
  filters: {
    toAreaUnit(value, unit) {
      return getFloatAreaInUnit(value, unit)
    },
    floatToFixedWithComma(value) {
      return toFixed(value, 2).replace(".", ",")
    },
  },
  computed: {
    Feature() {
      return this._FieldFeature()
    },
    Layer() {
      return this._FieldLayer()
    },
    areaUnitTypesList() {
      return AREA_UNIT_TYPES_LIST
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.fieldData.nmField = this.Feature["nm_field"]
      this.fieldData.abAreaUnit = this.Feature["ab_area_unit"]

      this.bkpFieldData = cloneDeep(this.fieldData)
      this.bkpLayer = cloneDeep(this.Layer)

      this.Layer.enableEdit()
      this.Layer.dragging.enable()
    })
  }
}
</script>

<style scoped></style>
